<div [ngClass]="styleClass">
    <div class="panel" [ngClass]="{'active': opened,'completed': completed && !disabled}">
        <div class="panel-heading" (click)="onToggle();">
            <h4 class="panel-title" [ngClass]="{'completed': completed && !disabled}">
                <span class="accordion-toggle"><i class="icon-play"></i>{{tabTitle}}</span>
                <button mat-icon-button matTooltip="{{ tooltip }}" matTooltipPosition="right" class="tooltip"
                        *ngIf="tooltip && opened && tooltipType != 'AUTOFILL'">
                    <i class="icon ic-icon_info"></i>
                </button>
                <button mat-icon-button matTooltip="{{ tooltip }}" matTooltipPosition="right" class="tooltip autofill"
                        *ngIf="tooltip && tooltipType == 'AUTOFILL'">
                    <i class="icon ic-icon_downland"></i>
                </button>
                <span class="section-indicator pull-right" *ngIf="completed && !disabled"><i class="icon ic-icon_tab_check"></i></span>
                <span class="section-indicator pull-right"><i [ngClass]="iconClass"></i></span>
            </h4>
        </div>
        <div class="panel-collapse" [ngClass]="{'hidden': !opened && hide}" *ngIf="opened || hide">
            <div class="panel-body">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>
